<script setup>
import FileSvg from "@/components/UI/FileSvg.vue";
import EditFileSvg from "@/components/UI/EditFileSvg.vue";
import {  ref, onBeforeMount, defineProps } from 'vue';
import { Api } from '@/service/api';

const props = defineProps({
    workflow_id: String
})

const files = ref([])

onBeforeMount(async () => {
    files.value = await Api.getWorkflowFiles(props.workflow_id)
})


function openSpreadsheet(spreadsheet_id, tab_id) {
    let url = "https://docs.google.com/spreadsheets/d/" + spreadsheet_id + "/edit?gid=" + tab_id
    window.open(url, '_blank')
}

</script>

<template>
    <div class="w-full h-full flex flex-col items-center overflow-y-auto">
        <div v-for="file in files" v-bind:key="file"
             class="flex items-center h-14 hover:bg-gray-100 border-t border-t-gray-200 w-full"
        >
            <div class="m-4">
                <FileSvg/>
            </div>
            <div class="ml-2">
                <div class="block whitespace-nowrap text-ellipsis overflow-hidden w-52 font-bold text-xs select-none">
                    {{ file.file_name }}
                </div>
                <div class="text-[10px] select-none">
                    Type: Google Sheets
                </div>
            </div>
            <div class="size-10 ml-auto mr-10 flex justify-center items-center rounded-full hover:bg-gray-200 cursor-pointer">
                <EditFileSvg v-on:click="openSpreadsheet(file.spreadsheet_id, file.tab_id)" />
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>